import React from "react";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { UserManagementPowFeatureResponse } from "../../../models/Administration";
import { camelToTitleCase } from "../../../utils";
import { Typography } from "@material-ui/core";

interface PowFeatureDisplayCardProps {
	//The pow feature to display the title and description for.
	feature: UserManagementPowFeatureResponse;
}

const useStyles = makeStyles((theme) => ({
	card: {
		borderRadius: theme.spacing(0.5),
		width: "100%",
	},
	cardContent: {
		padding: theme.spacing(1),
	},
}));

/**
 * Takes in a PowFeature and displays the description of the pow feature as well as the title of the feature.
 * @param props
 */
export const PowFeatureDisplayCard = (props: PowFeatureDisplayCardProps) => {
	const classes = useStyles();

	return (
		<Card className={classes.card}>
			<div className={classes.cardContent}>
				<div>
					<Typography
						style={{
							display: "flex",
							fontWeight: "bold",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: 6,
						}}
					>
						{camelToTitleCase(props.feature.powFeatureName)}
					</Typography>
				</div>
				<div>
					<Typography variant={"caption"}>{props.feature.description}</Typography>
				</div>
			</div>
		</Card>
	);
};
